import React from 'react';
import merge from 'merge';
import { bemClasses } from '../../helpers';
import { Markdown, TableRow, TreeSpace, TreeLeaf, } from '../../components';
var schemaPropertiesAccessors = [
    function (el) { return (React.createElement(React.Fragment, null,
        (function () {
            var treeSpaces = [];
            if (el.treeSpace) {
                for (var i = 0; i < el.treeSpace; i++) {
                    treeSpaces.push(React.createElement(TreeSpace, { key: i }));
                }
                treeSpaces.push(React.createElement(TreeLeaf, { key: el.treeSpace }));
            }
            return treeSpaces;
        })(),
        el.schema.key)); },
    function (el) { return React.createElement("span", null, el.schema.content.title); },
    function (el) { return (React.createElement("span", null,
        el.schema.content.type,
        el.schema.content.anyOf ? " " + el.schema.content.anyOf : '',
        el.schema.content.oneOf ? " " + el.schema.content.oneOf : '',
        el.schema.content.items && el.schema.content.items.type
            ? " (" + el.schema.content.items.type + ")"
            : '')); },
    function (el) { return React.createElement("span", null, el.schema.content.format); },
    function (el) { return React.createElement("span", null, el.schema.content.default); },
    function (el) {
        var enumElements = getEnumHTMLElements(el.schema);
        return (el.schema.content.description && (React.createElement("div", null,
            React.createElement(Markdown, null, el.schema.content.description),
            enumElements.length > 0 && React.createElement("div", null,
                "Enum: ",
                enumElements))));
    },
];
var getEnumHTMLElements = function (schema) {
    var enumElements = [];
    if (schema.content.enum && schema.content.enum.length) {
        enumElements = schema.content.enum.map(function (value, i) { return (React.createElement("span", { className: bemClasses.element("enum"), key: i },
            "\"",
            value,
            "\"")); });
    }
    return enumElements;
};
var handleNotProperty = function (prop) {
    if (prop.not) {
        var arrayOfChangedObjects = Object.entries(prop).map(function (_a) {
            var _b;
            var key = _a[0], val = _a[1];
            if (key === 'not') {
                return { properties: (_b = {}, _b[key] = val, _b) };
            }
            return prop[key];
        });
        return merge.recursive.apply(merge, arrayOfChangedObjects);
    }
    return prop;
};
var renderItems = function (schema, treeSpace) {
    var properties = schema.items && schema.items.properties ? schema.items.properties : null;
    if (!properties) {
        return null;
    }
    return renderProperties(schema.items, treeSpace);
};
var renderProperties = function (schema, treeSpace) {
    var properties = schema.properties;
    if (!properties) {
        return null;
    }
    return Object.entries(properties).map(function (_a) {
        var key = _a[0], prop = _a[1];
        return (React.createElement(SchemaPropertiesComponent, { key: key, name: key, properties: prop, treeSpace: treeSpace }));
    });
};
var renderOf = function (treeSpace, schemas) {
    if (!schemas) {
        return null;
    }
    return schemas.map(function (schema, index) {
        var id = index.toString();
        return (React.createElement(SchemaPropertiesComponent, { key: index, name: id, properties: schema, treeSpace: treeSpace }));
    });
};
export var SchemaPropertiesComponent = function (_a) {
    var name = _a.name, properties = _a.properties, treeSpace = _a.treeSpace;
    var alteredProperties = handleNotProperty(properties);
    var space = treeSpace + 1;
    var element = {
        schema: {
            key: name,
            content: alteredProperties,
        },
        treeSpace: treeSpace,
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(TableRow, { accessors: schemaPropertiesAccessors, element: element }),
        renderOf(space, alteredProperties.anyOf),
        renderOf(space, alteredProperties.oneOf),
        renderProperties(alteredProperties, space),
        renderItems(alteredProperties, space)));
};
//# sourceMappingURL=SchemaProperties.js.map